<template>
  <div class="dashboard_layout clearfix">
    <router-view class="content"/>
  </div>
</template>

<script>
import { browserInfo } from '@/libs/utils'

export default {
  name: 'DashboardLayout',
  created () {
    let body = document.querySelector('body')
    body.classList.add(browserInfo.name)
    document.documentElement.classList.add('dashboard-html')
  },
  destroyed () {
    let body = document.querySelector('body')
    body.classList.remove(browserInfo.name)
    document.documentElement.classList.remove('dashboard-html')
  }
}
</script>

<style lang="scss">
.dashboard_layout {
  min-width: 1400px;
  .header--wrap {
    .header {
      height: 46px;
    }
  }
}
</style>
